<script setup>
  import SideInquiry from '@components/SideInquiry.vue'

  import { useI18n } from '@shared/i18n.js'

  defineProps({
    agent: Object,
    propertyCode: String
  })

  const { t } = useI18n()
</script>
<template>
  <aside v-if="agent" class="side_menu col-3">
    <SideInquiry
      v-if="agent"
      :agent="agent"
      :property-code="propertyCode"
      :show-agent-name="false"
      :title="t('enquiries.show.js.contact_agent')"
    />
  </aside>
</template>
